// extracted by css-extract-rspack-plugin
export default {"title":"title-iTToxa","description":"description-NnFDp6","bold":"bold-PTcr30"};